import { Box } from "@mui/material";
import PropTypes from "prop-types";

/**
 * Frames a backend report document. The empty sandbox gives it an opaque origin with
 * no scripts, forms, popups, downloads or navigation. Never add allow-same-origin.
 */
export const ReportDocumentFrame = ({ html, title, sx }) => (
  <Box
    component="iframe"
    title={title}
    srcDoc={html}
    sandbox=""
    referrerPolicy="no-referrer"
    sx={{
      display: "block",
      width: "100%",
      height: "80vh",
      border: 1,
      borderColor: "divider",
      borderRadius: 1,
      bgcolor: "#e5e7eb",
      ...sx,
    }}
  />
);

ReportDocumentFrame.propTypes = {
  html: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  sx: PropTypes.object,
};
